// Date 2020-09-18 09:17:42

import sithMesAndonLightLevel from "@/store/sithMes/andon/SithMesAndonLightLevelStore.js";
import sithMesAndonPosition from "@/store/sithMes/andon/SithMesAndonPositionStore.js";
import sithMesAndonTask from "@/store/sithMes/andon/SithMesAndonTaskStore.js";
import sithMesAndonTaskExecute from "@/store/sithMes/andon/SithMesAndonTaskExecuteStore.js";
import sithMesAndonTaskSchedule from "@/store/sithMes/andon/SithMesAndonTaskScheduleStore.js";
import sithMesAndonType from "@/store/sithMes/andon/SithMesAndonTypeStore.js";
import sithMesAndonTypePosition from "@/store/sithMes/andon/SithMesAndonTypePositionStore.js";

const genericEntities = [
    'sithMesAndonLightLevel',
    'sithMesAndonPosition',
    'sithMesAndonTask',
    'sithMesAndonTaskExecute',
    'sithMesAndonTaskSchedule',
    'sithMesAndonType',
    'sithMesAndonTypePosition'
]

const entities = {
    sithMesAndonLightLevel,
    sithMesAndonPosition,
    sithMesAndonTask,
    sithMesAndonTaskExecute,
    sithMesAndonTaskSchedule,
    sithMesAndonType,
    sithMesAndonTypePosition
}

export {genericEntities}

export default entities